import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useSupabase } from "../../app/_components/providers/supabase-provider";
import { queryKeys } from "@src/queries";
import { Database } from "@src/types/db";
import { PlaylistSummary } from "@src/queries/getPlaylistsByUserId";

export const useInsertPlaylist = () => {
  const { supabase } = useSupabase();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ playlist }: {
      playlist: { userId: string, name: string }
    }) => {
      const { data } = await supabase
        .from("playlists")
        .insert([{ ...playlist }])
        .select("coverKey, createdAt, deletedAt, id, name, secret, status, updatedAt, userId")
        .single()
        .throwOnError();

      return data;
    },
    onSuccess: async (data, variables, _context) => {
      queryClient.setQueryData<Database['public']['Tables']['playlists']['Row']>(queryKeys.playlists.byId(data.id), data)
      queryClient.setQueryData<PlaylistSummary[]>(queryKeys.playlists.byUserId(variables.playlist.userId), (old) => {
        if (!old) return [{ ...data, songCount: 0 }]
        return [{ ...data, songCount: 0 }, ...old]
      })
    }
  })
}
